import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

// Shared blob-download helper for any "export to Excel"/"download record" flow (Approvals'
// downloadRecord, Reports' exportToExcel, ...). Reads the server-supplied file name off the
// X-File-Name response header (falling back to a caller-supplied name), then triggers a browser
// download of the blob body via a throwaway anchor element.
@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {
    downloadBlobResponse(
        response: HttpResponse<Blob>,
        fallbackFileName: string
    ): void {
        const blob = response.body;
        if (!blob) return;

        const fileName = response.headers.get('X-File-Name') ?? fallbackFileName;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }
}
